import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "searchOverlay_row" }

import { ref, watch, onBeforeUnmount } from 'vue'
import AcSearchInput from '@web/ui-kit/components/AcSearchInput.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchOverlay',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const draft = ref('')
const overlayRef = ref<HTMLElement | null>(null)

// Закрытие без сабмита стирает введённый текст (требование эпика SEARCH-HOME).
// Здесь же — блокировка/разблокировка скролла body по проектному паттерну (см. headers/mobile.vue).
watch(() => props.modelValue, (isOpen) => {
  if (!isOpen) draft.value = ''
  document.body.style = isOpen ? 'overflow: hidden; position: fixed; width: 100%;' : ''
})

// Если компонент размонтируют, пока оверлей открыт, — не оставляем body заблокированным навсегда.
onBeforeUnmount(() => {
  if (props.modelValue) document.body.style = ''
})

function close (): void {
  emit('update:modelValue', false)
}

function onSubmit (query: string): void {
  emit('submit', query)
  close()
}

// Простая фокус-ловушка: Tab/Shift+Tab не выпускают фокус за пределы оверлея.
function onTab (event: KeyboardEvent): void {
  const container = overlayRef.value
  if (!container) return

  const focusable = container.querySelectorAll<HTMLElement>(
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )
  if (focusable.length === 0) return

  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  const active = document.activeElement

  if (event.shiftKey) {
    if (active === first || !container.contains(active)) {
      event.preventDefault()
      last.focus()
    }
  } else {
    if (active === last) {
      event.preventDefault()
      first.focus()
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "overlayRef",
          ref: overlayRef,
          class: "searchOverlay",
          "data-test": "search-overlay",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "Поиск",
          onKeydown: [
            _withKeys(close, ["esc"]),
            _withKeys(onTab, ["tab"])
          ]
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AcSearchInput, {
              modelValue: draft.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draft).value = $event)),
              autofocus: "",
              clearable: "",
              onSubmit: onSubmit
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              class: "searchOverlay_close",
              "data-test": "search-overlay-close",
              type: "button",
              "aria-label": "Закрыть",
              onClick: close
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M19 5L5 19M5 5L19 19",
                  stroke: "#697076",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ]))])
          ])
        ], 544))
      : _createCommentVNode("", true)
  ]))
}
}

})